<mat-label class="firstLabel">{{label}}</mat-label>
<mat-label class="subLabel">
    <span class="headerstatusIndicator" [ngStyle]="{'background-color': color}"></span>{{subLabel}}<span
      *ngIf="date" class="subLabel"> - {{helperService.getTranslatedDate(date, 'dd-MMM-yyyy')}}</span>
</mat-label>